/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import store from '../store';

// Routes
import paths, { shopifySections } from './paths';
import { Routes } from '@/helpers/consts';

function route({ view, name, props, children = [], ...routeData }) {
  return {
    name: view === 'TabView' ? name : name || view?.split('/').pop() || '',
    component: resolve => import(`@/views/${view.split('_')[0]}.vue`).then(resolve),
    children: children.map(path => route({ ...path, path: path.path.replace(/^\//, '') })),
    props,
    ...routeData,
  };
}

Vue.use(Router);

const routes = paths.map(path => route(path));
// Create a new router
const router = new Router({
  base: '/dashboard',
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash && from.name !== 'Auth') {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const { trialEnded, account, auth, planPick } = Routes;
  const queryParams = to.fullPath.split('?')[1] || '';

  if (to.name === 'Welcome') {
    document.body.classList.add('opinew-onboarding');
  } else {
    document.body.classList.remove('opinew-onboarding');
  }

  if (from.path.split('/')[1] && from.path.split('/')[1] !== to.path.split('/')[1]) {
    store.commit('updateLoadingCount', 1);
    setTimeout(() => {
      store.commit('updateLoadingCount', -1);
    }, 100);
  }

  if (to.path === auth) {
    sessionStorage.removeItem('vuex');
    next();
  } else if (
    store.state.accountInfo.shopNeedsToChoosePlan &&
    ![trialEnded, account, planPick].includes(to.path) &&
    !queryParams.includes('subscription_activated=true')
  ) {
    next({ name: 'TrialEnded', hash: to.hash });
  } else if (to.name !== 'Welcome' && queryParams.includes('welcome_screen=')) {
    const welcome_screen_step = new URLSearchParams(window.location.search).get('welcome_screen');
    next({
      name: 'Welcome',
      params: { step: welcome_screen_step },
      hash: to.hash,
    });
  } else {
    store.dispatch('hideSaverbar');

    const nextSectionIndex = shopifySections.findIndex(el => el.path === to.matched[0].path);

    if (window.opwBridge) {
      window.opwBridge.setActive(nextSectionIndex);
    }

    next();
  }
});

Vue.use(Meta);

export default router;
